/**
 * The policies in a bucket of the policy premium search (`/search/premium`, `aggregateIndustry`, `aggregateState`).
 *
 * Those searches sum premium over policies and their mid-term endorsements, so a bucket's `doc_count` counts both. The
 * backend adds a `Policies` sub-count that leaves endorsements out; that is the number to show as policies. A bucket
 * from a backend without it falls back to `doc_count`.
 */
export function policyBucketCount(bucket: unknown): number {
  if (bucket == null || typeof bucket !== 'object') {
    return 0;
  }
  const { Policies, doc_count } = bucket as {
    readonly Policies?: { readonly doc_count?: number };
    readonly doc_count?: number;
  };
  return Policies?.doc_count ?? doc_count ?? 0;
}
